<template>
  <div class="integral-record">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>积分记录</span>
          <el-button type="primary" @click="handleRefresh">刷新</el-button>
        </div>
      </template>
      
      <el-table :data="recordList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="user_name" label="用户" />
        <el-table-column prop="type" label="类型">
          <template #default="{ row }">
            <el-tag :type="row.type === 1 ? 'success' : 'danger'">
              {{ row.type === 1 ? '获得' : '消耗' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="points" label="积分">
          <template #default="{ row }">
            <span :style="{ color: row.type === 1 ? '#67C23A' : '#F56C6C' }">
              {{ row.type === 1 ? '+' : '-' }}{{ row.points }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="说明" />
        <el-table-column prop="created_at" label="时间" />
      </el-table>
      
      <el-pagination
        v-model:current-page="page"
        v-model:page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        style="margin-top: 20px"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'

export default {
  name: 'IntegralRecord',
  setup() {
    const recordList = ref([])
    const loading = ref(false)
    const page = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    
    const fetchRecords = async () => {
      loading.value = true
      try {
        const res = await request.get('/api/admin/integral-records', {
          params: { page: page.value, limit: pageSize.value }
        })
        recordList.value = res.data || []
        total.value = res.total || 0
      } catch (error) {
        ElMessage.error('获取记录失败')
      } finally {
        loading.value = false
      }
    }
    
    const handleRefresh = () => {
      fetchRecords()
    }
    
    const handlePageChange = (val) => {
      page.value = val
      fetchRecords()
    }
    
    onMounted(() => {
      fetchRecords()
    })
    
    return {
      recordList,
      loading,
      page,
      pageSize,
      total,
      handleRefresh,
      handlePageChange
    }
  }
}
</script>

<style scoped>
.integral-record {
  padding: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.card-header span {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

/* 积分颜色 */
:deep(.el-table) .text-success {
  color: #67C23A;
  font-weight: 600;
}

:deep(.el-table) .text-danger {
  color: #F56C6C;
  font-weight: 600;
}
</style>
